import React, { useContext, useEffect, useState } from "react";
// import Box from "@mui/material/Box";
// import Fab from "@mui/material/Fab";
import instance from "../api/api";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AddShoppingCart from "@mui/icons-material/AddShoppingCart";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import jwt_decode from "jwt-decode";

import {
  Button,
  CardActionArea,
  CardActions,
  Grid,
  TextField,
} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import CheckIcon from "@mui/icons-material/Check";
import AppleIcon from "@mui/icons-material/Apple";
import PaymentIcon from "@mui/icons-material/Payment";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
// import { makeStyles } from "@mui/styles";
// import { createMuiTheme } from '@mui/styles';
import { ThemeProvider, createTheme } from "@mui/material/styles";
// import AspectRatio from "@mui/joy/AspectRatio";
import { Context } from "../context/ContextProvider";
import Paper from "@mui/material/Paper";
import CartItem from "../components/Cart/CartItem/CartItem";
import CartItemM from "../components/Cart/CartItemM";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import { Stepper, Step, StepLabel } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ButtonGroup from "@mui/material/ButtonGroup";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import Payment from "./Payment";
import CircularProgress from "@mui/material/CircularProgress";
import { fontWeight } from "@mui/system";
import axios from "axios";
import CancelIcon from '@mui/icons-material/Cancel';
var isSafari = (navigator.vendor.match(/apple/i) || "").length > 0;

const Img = styled("img")({
  margin: "auto",
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
});
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  // paddingTop:theme.spacing(3),
  // marginRight:theme.spacing(1),
  textAlign: "center",
  // color: theme.palette.text.secondary,
  // borderColor: "red",
  // borderWidth: "2px",
  // borderRadius: "2px",
  // border: 2,
}));

const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
      // direction: "rtl",
    },
  },
  paper: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(0),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  table: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
  },
  avatar: {
    marginBottom: theme.spacing(0),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  icons: {
    display: "flex",
    flexDirection: "row",
    position: "fixed",
    top: 5,
    right: 5,
  },
}));

export default function Checkout({ t }) {
  let navigate = useNavigate();

  const {
    categories,
    items,
    setItems,
    addOrder,
    setOrders,
    orders,
    newList,
    setNewList,
    amountOfItemsInCart,
    handleAddProduct,
    cartItmes,
    setCartItems,
    handleRemoveProduct,
    totalPrice,
    token,
    values,
    setValues,
  } = useContext(Context);

  // Apple Pay

  const [data, setData] = React.useState(null);
  const [data2, setData2] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const orderId = React.useRef(null);

  const fetchPayment = async (token, response) => {
    console.log("id type: ", typeof orderId.current);
    const idd = Number(orderId.current);
    console.log("id type: ", typeof idd);
    // setData(JSON.stringify({ token: token }))
    // e.preventDefault();
    // fetch("https://jsonplaceholder.typicode.com/todos/1")
    //   .then((response) => response.json())
    //   .then((json) => console.log(json));

    // console.log("token: ", token);
    const { version, data, signature, header } = token.paymentData;
    console.log("data: ", data, "signature: ", signature);
    const { ephemeralPublicKey, publicKeyHash, transactionId } = header;

    fetch(
      "https://fatora-sa.herokuapp.com/api/v1/push/fetchNoonPaymentProcess",
      {
        method: "POST",
        body: JSON.stringify({
          apiOperation: "PROCESS_AUTHENTICATION",
          order: {
            id: idd,
          },
          paymentData: {
            type: "ApplePay",
            data: {
              paymentInfo: JSON.stringify({ token: token }),
            },
          },
        }),
        headers: {
          "Content-type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => console.log("data noon: ", data))
      .then(async () => {
        console.log("success");
        const status = "success";
        await response.complete(status);
      })
      .catch(() => (error) => console.log("error: ", error.message));
  };

  async function onApplePayButtonClicked() {
    // Consider falling back to Apple Pay JS if Payment Request is not available.
    if (!PaymentRequest) {
      return;
    }

    try {
      // Define PaymentMethodData
      const paymentMethodData = [
        {
          supportedMethods: "https://apple.com/apple-pay",
          data: {
            version: 3,
            // merchantIdentifier: "merchant.com.adeb1991.explicationyourdream",
            merchantIdentifier: "merchant.me.naem",
            merchantCapabilities: [
              "supports3DS",
              "supportsCredit",
              "supportsDebit",
            ],
            supportedNetworks: [
              "amex",
              "discover",
              "masterCard",
              "visa",
              "mada",
            ],
            countryCode: "SA",
          },
        },
      ];
      // Define PaymentDetails
      const paymentDetails = {
        total: {
          label: "iphone 5",
          amount: {
            value: "1",
            currency: "SAR",
          },
        },
      };
      // Define PaymentOptions
      const paymentOptions = {
        requestPayerName: false,
        requestBillingAddress: false,
        requestPayerEmail: false,
        requestPayerPhone: false,
        requestShipping: true,
        shippingType: "shipping",
      };

      // Create PaymentRequest
      const request = new PaymentRequest(
        paymentMethodData,
        paymentDetails,
        paymentOptions
      );

      request.onmerchantvalidation = (event) => {
        // Call your own server to request a new merchant session.
        console.log("event: ", event);
        console.log("event: ", event.validationURL);

        fetch("https://fatora-sa.herokuapp.com/api/v1/push/fetchNoonPayment", {
          method: "POST",
          body: JSON.stringify({
            validationUrl:
              "https://apple-pay-gateway.apple.com/paymentservices/startSession",
          }),
          headers: {
            "Content-type": "application/json",
          },
        })
          .then((res) => res.json())
          .then(
            (data) =>
              console.log("data id: ", data.id, data.validationData) &
              setData2(JSON.parse(data.validationData)) &
              (orderId.current = data.id) &
              event.complete(JSON.parse(data.validationData))
          )
          .catch((err) => console.log("error: ", err));
      };

      request.onpaymentmethodchange = (event) => {
        if (event.methodDetails.type !== undefined) {
          console.log("event: 1", orderId);
          // Define PaymentDetailsUpdate based on the selected payment method.
          // No updates or errors needed, pass an object with the same total.
          const paymentDetailsUpdate = {
            total: paymentDetails.total,
          };
          event.updateWith(paymentDetailsUpdate);
        } else if (event.methodDetails.couponCode !== undefined) {
          // Define PaymentDetailsUpdate based on the coupon code.
          // console.log("event: ", event.methodDetails.couponCode);

          const total = 1;
          // const total = calculateTotal(event.methodDetails.couponCode);
          const displayItems = "fsd";
          const shippingOptions = [
            {
              id: "ground",
              label: "Ground Shipping",
              amount: { value: "5.00", currency: "USD" },
              selected: true,
            },
            {
              id: "express",
              label: "Express Shipping",
              amount: { value: "10.00", currency: "USD" },
            },
          ];
          const error = null;

          event.updateWith({
            total: total,
            displayItems: displayItems,
            shippingOptions: shippingOptions,
            modifiers: [
              {
                data: {
                  additionalShippingMethods: shippingOptions,
                },
              },
            ],
            error: error,
          });
        }
      };

      request.onshippingoptionchange = (event) => {
        console.log("event: 2");

        // Define PaymentDetailsUpdate based on the selected shipping option.
        // No updates or errors needed, pass an object with the same total.
        const paymentDetailsUpdate = {
          total: paymentDetails.total,
        };
        event.updateWith(paymentDetailsUpdate);
      };

      request.onshippingaddresschange = (event) => {
        console.log("event: 3", orderId);

        // Define PaymentDetailsUpdate based on a shipping address change.
        const paymentDetailsUpdate = {};
        event.updateWith(paymentDetailsUpdate);
      };

      // request.canMakePayment().then(async (canMakePayment) => {
      //   console.log("data make: ", request);

      // });
      const response = await request.show();
      const { token } = response.details;
      console.log("data res: ", token, orderId);
      // console.log("data res: ", response);
      setData(JSON.stringify({ token: token }));
      fetchPayment(token, response);
    } catch (e) {
      // Handle errors
      console.log("error: ", e.message);
    }
  }

  // React.useEffect(() => {
  //   console.log("isSafari: ", isSafari);
  //   // const resetButton = document.getElementById("apple-pay");

  //   // resetButton.addEventListener("click", function (e) {
  //   //   console.log("here press ...");
  //   //   window.location.replace("https://naem.me");
  //   //   // onApplePayButtonClicked();
  //   // });
  // }, []);

  useEffect(() => {
    console.log("isSafari: ", jwt_decode(localStorage.getItem("Token")).user);

    instance
      .get(`/users/login/${jwt_decode(localStorage.getItem("Token")).user._id}`)
      .then(
        ({ data }) => data._id != null && setValues(data) & setIsLoading(false)
      )
      .catch((error) => console.log("error: ", error.message));

    // localStorage.getItem("dataKey") != null &&
    //   console.log("dajjjj: ", JSON.parse(localStorage.getItem("Order")).orders);
    localStorage.getItem("Order") != null &&
      setCartItems(JSON.parse(localStorage.getItem("Order")));

    console.log("cart item:", cartItmes);
  }, []);

  const [activeStep, setActiveStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  // var isSafari = window.safari !== undefined;

  const kindSex = ["البحرين", "قطر", "الكويت", "الإمارات", "السعودية"];
  const kindPaymentChoose = ["ابل باي", "مدى", "فيزا", "تحويل"];

  const [paymentSelect, setPaymentSelect] = useState([
    {
      id: 1,
      select: isSafari,
      name: "applepay",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b0/Apple_Pay_logo.svg",
    },
    {
      id: 2,

      select: isSafari === false ? true : false,
      name: "mada",
      url: "https://mulfet.com/vendor/checkout/images/icons/pay-option-mada.svg",
    },
    {
      id: 3,

      select: false,
      name: "credit",
      url: "https://mulfet.com/vendor/checkout/images/icons/pay-option-credit-2.svg",
    },
    // {
    //   id: 4,

    //   select: false,
    //   name: "bank",
    //   url: "https://mulfet.com/vendor/checkout/images/icons/pay-option-bank-acc.svg",
    // },
  ]);
  // const [values, setValues] = React.useState({
  //   country: "السعودية",
  //   email:
  //     localStorage.getItem("Token") == null
  //       ? ""
  //       : jwt_decode(localStorage.getItem("Token")).user.email,
  //   displayName:
  //     localStorage.getItem("Token") == null
  //       ? ""
  //       : jwt_decode(localStorage.getItem("Token")).user.displayName,
  //   phone:
  //     localStorage.getItem("Token") == null
  //       ? ""
  //       : jwt_decode(localStorage.getItem("Token")).user.phone,
  //   city:
  //     localStorage.getItem("Token") == null
  //       ? ""
  //       : jwt_decode(localStorage.getItem("Token")).user.city,
  //   address:
  //     localStorage.getItem("Token") == null
  //       ? ""
  //       : jwt_decode(localStorage.getItem("Token")).user.address,
  //   neighborhood:
  //     localStorage.getItem("Token") == null
  //       ? ""
  //       : jwt_decode(localStorage.getItem("Token")).user.neighborhood,
  //   kindPaymentField: isSafari ? paymentSelect[0].name : paymentSelect[1].name,
  // });

  const [isSelect, setIsSelect] = useState(false);
  const [arr, setArr] = useState([]);
  const [isApplePay, setIsApplePay] = useState(true);
  const [choosePay, setChoosePay] = useState(
    isSafari ? paymentSelect[0].name : paymentSelect[1].name
  );

  const handleChange = (prop) => (event) => {
    // console.log("token: ", event);
    setValues({ ...values, [prop]: event.target.value });
    // console.log("kind payment: ", event.target.kindPaymentField);

    // event.target.name === "kindPaymentField" && setKindPayment(true);
  };

  var change = (id, select) => {
    setArr(
      paymentSelect.map((obj, key) => {
        // console.log("data: ", obj.name);

        // if (isSafari === false && obj.name === "applepay") {
        //   alert("لا يمكن الدفع إلا من خلال متصفح سفاري");
        //   return { ...obj };
        // } else {
        if (obj.id === id) {
          setChoosePay(obj.name);
          isSafari && obj.name === "applepay"
            ? setIsApplePay(true)
            : setIsApplePay(false);
          // if (isSafari === false && obj.name === "applepay") {
          //   alert("لا يمكن الدفع إلا من خلال متصفح سفاري");
          //   return { ...obj };
          // }
          return { ...obj, select };
        }
        return { ...obj, select: false };
        // }
      })
    );
    return paymentSelect.map((obj) => {
      if (obj.id === id) {
        setChoosePay(obj.name);
        setValues({ ...values, kindPaymentField: obj.name });
        return { ...obj, select };
      }
      return { ...obj, select: false };
    });
  };

  // useEffect(() => {
  //   console.log("data: ",change.length === 4);
  // }, [paymentSelect])

  const kindSocialState = [
    "متزوج/متزوجة",
    "أعزب/عزباء",
    "أرمل/أرملة",
    "مطلق/مطلقه",
  ];
  const kindWorkingCase = ["موظف/موظفة", "غير موظف/غير موظفة"];

  // const [autoCC, setAutoCC] = useState(false);

  const [isFindAddress, setIsFindAddress] = useState(true);
  const [kindPayment, setKindPayment] = useState(true);

  useEffect(() => {
    // console.log("token: ", jwt_decode(token).user.city);
    // ProcessCheckoutPayment()
  }, []);

  const fetchPaymentCardPageCheckOut = () => {
    fetch("https://fatora-sa.herokuapp.com/api/v1/push/mada", {
      method: "POST",
      // body: JSON.stringify({
      //   apiOperation: "PROCESS_AUTHENTICATION",
      //   order: {
      //     id: idd,
      //   },
      //   paymentData: {
      //     type: "ApplePay",
      //     data: {
      //       paymentInfo: JSON.stringify({ token: token }),
      //     },
      //   },
      // }),
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("success", data.result);
        window.location.replace(data.result.checkoutData.postUrl);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      })
      .catch(() => (error) => console.log("error: ", error.message));
  };

  const addNewDream = async (e) => {
    // setLoading(true);
    e.preventDefault();
    console.log("data: ", values);
    setIsFindAddress(true);

    if (values != null) {
      await instance
        .post("/users/update-user", {
          displayName: values.displayName,
          phone: values.phone,
          city: values.city,
          address: values.address,
          neighborhood: values.neighborhood,
          // email: jwt_decode(localStorage.getItem("Token")).user.email,
        })
        .catch((error) => console.log("error: ", error.message));

      // await axios.post(
      //   "https://fatora-sa.herokuapp.com/api/v1/users/update-user",
      //   {
      //     displayName: values.displayName,
      //     phone: values.phone,
      //     city: values.city,
      //     address: values.address,
      //     neighborhood: values.neighborhood,
      //     // email: jwt_decode(localStorage.getItem("Token")).user.email,
      //   },
      //   {
      //     headers: {
      //       Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NzkyODU5NTcsInVzZXIiOnsiX2lkIjoiNjQwOWY3Y2M0ZTM5Yzg0MWMzZjAwNjU1IiwiZGlzcGxheU5hbWUiOiJJdWx1IiwiZW1haWwiOiJsdWx1QGdtYWlsLmNvbSIsImFkbWluIjpmYWxzZSwiYWRkcmVzcyI6IiIsImNpdHkiOiIiLCJuZWlnaGJvcmhvb2QiOiIiLCJwaG9uZSI6IiJ9LCJpYXQiOjE2Nzg0MjE5NTd9.EjjZWHRzcKns8d1Pcq45gDIdkeVcUcAg5pKpzarj5pk",
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
    }

    // if (password === "") {
    //   setLoading(false);

    //   alert("Password cannot be empty");
    //   return;
    // }

    // if (password.length < 7) {
    //   setLoading(false);
    //   alert("Password is very small");
    //   return;
    // }

    // setPassword(password);
    // console.log("values: ",values);
    // let result;

    // result =
    //   setValues({
    //     country: "",
    //     email: "",
    //     displayName: "",
    //     phone: "",
    //     city: "",
    //     address: "",
    //     neighborhood: "",
    //     kindPaymentField: "",
    //   }) & alert("تم إضافة المعومات بنجاح");

    // try {
    //   instance
    //     .post(`/questions/create-question-by-email`, values)
    //     .then(({ data }) => {
    //       // console.log("data: ",  data , );

    //       if (typeof data == "string" && data.startsWith("you") === true) {
    //         result = alert("يوجد خطأ  في البريد أو الرقم السري");
    //       } else {
    //         // console.log("data: ",  data.itemNo);

    //         // sendPushNotificationToAdmin(data.itemNo);
    //         result =
    //           setValues({
    //             email: "",
    //             ps: "",
    //             title: "",
    //             selectSex: "",
    //             socialState: "",
    //             workingCase: "",
    //             age: "",
    //             active: true,
    //             chooseType: "chat1999",
    //           }) & alert("تم إضافة الحلم بنجاح");

    //         // history.replace(location);
    //       }
    //       return result;
    //     });
    //   setPassword("");

    //   setTimeout(() => {
    //     setLoading(false);
    //   }, 1000);
    // } catch (error) {
    //   setTimeout(() => {
    //     setLoading(false);
    //   }, 1000);
    //   console.clear();
    //   console.error("Sorry .. you can't access this page");
    // }
  };

  return (
    // <Container
    //   sx={{
    //     mt: "100px",
    //     // p: 2,
    //     // margin: "auto",
    //     // m: 2,
    //     // // maxWidth: 500,
    //     // flexGrow: 1,
    //     backgroundColor: (theme) =>
    //       theme.palette.mode === "dark" ? "#1A2027" : "#F6F6F6",
    //   }}
    // >
    <Container style={{ paddingTop: 50, paddingBottom: 20 }}>
      {isFindAddress === true ? (
        <Box width="100%" height={"50px"} p="50px" pt="0px">
          <Stepper
            style={{ backgroundColor: "#F6F6F6" }}
            activeStep={activeStep}
            sx={{ m: "20px 0" }}
          >
            <Step>
              <StepLabel> </StepLabel>
            </Step>
            <Step>
              <StepLabel> </StepLabel>
            </Step>
          </Stepper>
        </Box>
      ) : null}

      <Box
        sx={{
          // p: 2,
          // margin: "auto",
          m: 2,
          pt: "10px",
          // maxWidth: 500,
          // flexGrow: 1,
          // backgroundColor: (theme) =>
          //   theme.palette.mode === "dark" ? "#1A2027" : "#fff",
        }}
      >
        <Grid display={"flex"} item xs={12}>
          <LocalShippingIcon
            style={{ marginLeft: 10, color: "black", marginTop: 5 }}
          />
          <Typography variant="h5"> معلومات التواصل </Typography>
        </Grid>
        {/* <Grid justifyContent="center" spacing={1}> */}

        {isFindAddress === true ? (
          <Paper
            display={"flex"}
            xs={12}
            sx={{
              p: 1,
              // margin: "auto",
              mt: 1,
              mb: kindPayment ? 1 : 0,

              // maxWidth: 500,
              flexGrow: 1,
              //   borderRadius:'20px',
              borderEndEndRadius: kindPayment ? null : "0px",
              borderEndStartRadius: kindPayment ? null : "0px",
              //   borderColor: "green",
              // borderColor:'blue',
              // borderWidth:"3",
              backgroundColor: (theme) =>
                theme.palette.mode === "dark" ? "#1A2027" : "#fff",
            }}
            variant="outlined"
          >
            <Grid container>
              <Grid item xs={9} sm={10} md={11} lg={11} xl={11}>
                {/* <Box style={{ backgroundColor: "red" }}>dfdsa</Box> */}
                {isLoading === false ? (
                  <Box
                    display={"flex"}
                    alignItems="center"
                    pt={
                      values?.city.length > 1 && values?.phone.length > 8
                        ? 0.6
                        : 0.2
                    }
                  >
                    {values?.city.length > 1 &&
                    values?.phone.length > 8 &&
                    values?.neighborhood.length > 1 ? (
                      <FmdGoodIcon
                        style={{ marginLeft: "5px", color: "black" }}
                      />
                    ) : (
                      <AddLocationAltIcon
                        style={{ marginLeft: "5px", color: "black" }}
                      />
                    )}
                    <Typography mr={5} variant="body2">
                      {values?.city.length > 1 &&
                      values?.phone.length > 8 &&
                      values?.neighborhood.length > 1
                        ? values?.city + " - " + values?.neighborhood
                        : "لا يوجد عنوان حالياً"}
                    </Typography>
                  </Box>
                ) : (
                  <CircularProgress style={{ color: "gray" }} size={20} />
                )}
              </Grid>
              {values?.city.length > 1 &&
                values?.phone.length > 8 &&
                values?.neighborhood.length > 1 && (
                  <Grid item xs={3} sm={2} md={1} lg={1} xl={1}>
                    {/* <Box>hh</Box> */}
                    <Button
                      //   sx={{ mt: 1 }}
                      type="submit"
                      size="medium"
                      startIcon={<EditIcon />}
                      //   backgroundColor={"red"}
                      // fullWidth
                      variant="outlined"
                      onClick={() => {
                        console.log("data item: ");
                        setIsFindAddress(false);
                        // setActiveStep(2);
                        // navigate(`/payment`);
                      }}
                    >
                      تغيير
                    </Button>
                  </Grid>
                )}
            </Grid>
          </Paper>
        ) : null}

        {isFindAddress === true ? (
          <Box sx={{ m: 0, mb: 1 }}>
            <Button
              sx={{ p: 1 }}
              // type="submit"
              size="large"
              startIcon={<AddIcon />}
              //   backgroundColor={"red"}
              fullWidth
              variant="outlined"
              style={{ borderStyle: "dashed" }}
              onClick={() => {
                console.log("data item: ");
                setIsFindAddress(false);
                // setActiveStep(2);
                // navigate(`/payment`);
              }}
            >
              إضافة عنوان جديد
            </Button>
          </Box>
        ) : null}
      </Box>

      {/* {isFindAddress === true ? (
        <Box sx={{ m: 2 }}>
          <Button
            sx={{ p: 1 }}
            type="submit"
            size="large"
            startIcon={<AddIcon />}
            //   backgroundColor={"red"}
            fullWidth
            variant="outlined"
            onClick={() => {
              console.log("data item: ");
              setIsFindAddress(false);
              // setActiveStep(2);
              // navigate(`/payment`);
            }}
          >
            إضافة عنوان جديد
          </Button>
        </Box>
      ) : null} */}

      {isFindAddress === false ? (
        <Box
          sx={{
            // p: 2,
            margin: "auto",
            m: 2,
            mt:0,
            // maxWidth: 500,
            flexGrow: 1,
            // backgroundColor: (theme) =>
            //   theme.palette.mode === "dark" ? "#1A2027" : "#fff",
          }}
        >
          <Grid container justifyContent="center">
            {/* <Grid item xs={12} >
              <Typography variant="h5">معلومات التوصيل</Typography>
            </Grid> */}
            <Grid item xs={12}>
              <form noValidate onSubmit={addNewDream} id="formR">
                <TextField
                  select
                  label="الدولة"
                  name="country"
                  onChange={handleChange("country")}
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  required
                  value={values?.country}
                  SelectProps={{
                    native: true,
                  }}
                >
                  {kindSex.map((option, key) => (
                    <option key={key} value={option}>
                      {option}
                    </option>
                  ))}
                </TextField>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="المدينة"
                  name="city"
                  value={values?.city}
                  onChange={handleChange("city")}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="الحي"
                  name="neighborhood"
                  value={values?.neighborhood}
                  onChange={handleChange("neighborhood")}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="العنوان"
                  name="address"
                  value={values?.address}
                  onChange={handleChange("address")}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="اسم المستلم"
                  name="displayName"
                  value={values?.displayName}
                  onChange={handleChange("displayName")}
                />
                {/* <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="البريد الإلكتروني"
                  name="email"
                  value={values.email}
                  onChange={handleChange("email")}
                /> */}
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="رقم الجوال"
                  name="phone"
                  value={values?.phone}
                  onChange={handleChange("phone")}
                />

                <Grid item xs={12} mt={2}>
                  <Button
                    type="submit"
                    size="large"
                    startIcon={<AddIcon />}
                    fullWidth
                    sx={{ width: "100%", padding: 1 }}
                    variant="contained"
                    // onClick={() => {
                    //   //   console.log("data item: ");
                    //   //   setActiveStep(2);
                    //   //   navigate(`/payment`);
                    //   setIsFindAddress(true);
                    // }}
                  >
                    إضافة عنوان
                  </Button>
                </Grid>
                <Grid item xs={12} mt={2}>
                  <Button
                    // type="submit"
                    size="large"
                    startIcon={<CancelIcon />}
                    fullWidth
                    sx={{ width: "100%", padding: 1 }}
                    variant="outlined"
                    onClick={() => {
                      //   console.log("data item: ");
                      //   setActiveStep(2);
                      //   navigate(`/payment`);
                      setIsFindAddress(true);
                    }}
                  >
                    إلغاء
                  </Button>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Box>
      ) : null}

      {/* {cartItmes.length === 0 ? (
        <Box
          display="flex"
          alignItems="center"
          border={`1.5px solid #e2e1e1`}
          m="20px"
          p="2px 5px"
        >
          This is Cart is Empty ...
          <Button onClick={() => navigate(`/home`)}>back</Button>
        </Box>
      ) : null} */}

      {isFindAddress === true ? (
        <Box
          sx={{
            margin: "auto",
            m: 2,
            flexGrow: 1,
          }}
        >
          <Grid display={"flex"} pb={1} item xs={12}>
            <AccountBalanceWalletIcon
              style={{ marginLeft: 10, color: "black", marginTop: 5 }}
            />
            <Typography variant="h5">الدفع</Typography>
          </Grid>

          <Grid
            container
            mb={2}
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
          >
            {isSelect
              ? arr
                  .filter((i) => (isSafari === false ? i.id > 1 : i.id > 0))
                  .map((kind, key) => {
                    return (
                      <Grid key={kind.id} item xs={isSafari === false ? 6 : 4}>
                        <Item
                          onClick={() => {
                            change(kind.id, true);
                            setIsSelect(true);
                          }}
                          sx={{
                            border: kind.select === true ? 2 : 0,
                            borderColor: "black",
                            padding: kind.select === true ? 1.8 : 2,
                          }}
                        >
                          <Box
                            component="img"
                            sx={{
                              height: 25,
                              width: 75,
                            }}
                            alt={kind.name}
                            src={kind.url}
                          />
                        </Item>
                      </Grid>
                    );
                  })
              : paymentSelect
                  .filter((i) => (isSafari === false ? i.id > 1 : i.id > 0))
                  .map((kind, key) => {
                    return (
                      <Grid key={kind.id} item xs={isSafari === false ? 6 : 4}>
                        <Item
                          onClick={() => {
                            change(kind.id, true);
                            setIsSelect(true);
                          }}
                          sx={{
                            border: kind.select === true ? 2 : 0,
                            borderColor: "black",
                            padding: kind.select === true ? 1.8 : 2,
                          }}
                        >
                          <Box
                            component="img"
                            sx={{
                              height: 25,
                              width: 75,
                            }}
                            alt={kind.name}
                            src={kind.url}
                          />
                        </Item>
                      </Grid>
                    );
                  })}
          </Grid>
        </Box>
      ) : null}

      {isApplePay && isSafari && isFindAddress === true ? (
        <Box
          sx={{
            m: 2,
            backgroundColor: "black",
            height: "40px",
            borderRadius: "5px",
          }}
        >
          <Button
            style={{
              width: "100%",
              height: "100%",
              color: "white",
              textTransform: "none",
              fontWeight: "bold",
            }}
            endIcon={!loading && <AppleIcon />}
            autoCapitalize={false}
            onClick={() => {
              setLoading(true);
              setActiveStep(2);
              localStorage.setItem("Price", totalPrice.toFixed(2));
              localStorage.setItem("ChoosePay", choosePay);
            }}
          >
            {loading ? (
              <>
                <CircularProgress
                  style={{ marginLeft: 10 }}
                  size={20}
                  color="inherit"
                />
                الرجاء الإنتظار
              </>
            ) : (
              "شراء باستخدام Pay"
            )}
          </Button>
        </Box>
      ) : (
        isFindAddress === true && (
          <Box
            sx={{
              m: 2,
              backgroundColor: "green",
              height: "40px",
              borderRadius: "5px",
            }}
          >
            <Button
              // style={{margin:10}}
              style={{
                width: "100%",
                height: "100%",
                color: "white",
                textTransform: "none",
                fontWeight: "bold",
              }}
              endIcon={!loading && <KeyboardBackspaceIcon />}
              onClick={() => {
                setLoading(true);
                fetchPaymentCardPageCheckOut();
                setActiveStep(2);
                localStorage.setItem("Price", totalPrice.toFixed(2));
                localStorage.setItem("ChoosePay", choosePay);
              }}
            >
              {loading ? (
                <>
                  <CircularProgress
                    style={{ marginLeft: 10 }}
                    size={20}
                    color="inherit"
                  />
                  الرجاء الإنتظار
                </>
              ) : (
                "إكمال الدفع"
              )}
            </Button>
          </Box>
        )
      )}

      {/* <Button
        onClick={() => {
          // console.log("paymentSelect: ", choosePay);
          // localStorage.setItem(
          //   "AllData",
          //   JSON.stringify({
          //     orders: cartItmes,
          //     user: values,
          //     price: totalPrice.toFixed(2),
          //   })
          // );

          localStorage.setItem("ChoosePay", choosePay);

          // navigate("/current-order?orderId=152441441834&merchantReference=Atr");
        }}
      >
        press
      </Button> */}

      {/* <apple-pay-button
        id="apple-pay"
        style={{
          "--apple-pay-button-width": "140px",
          "--apple-pay-button-height": "30px",
          "--apple-pay-button-border-radius": "5px",
          "--apple-pay-button-padding": "5px 0px",
        }}
        buttonstyle="black"
        type="buy"
        locale="ar-SA"
        // onClick={() => console.log("press here .. 33")}
      ></apple-pay-button> */}

      <Box width="80%" m="100px auto 50px auto" height={"50px"} p="20px "></Box>
    </Container>
  );
}

// https://mulfet.com/checkout/mxqxGkdMO6NnXKo301VE7JzYQbX1xojWpLmWyAe9Zg2b48Dwr5BalRjZ

// const jjj = {
//   orders: [
//     {
//       _id: "637624ff9f59798d8971e7ff",
//       name: "ارماني يو ليذر الذهبي الجديد 100 مل",
//       key: 397,
//       marker: "جورجيو ارماني",
//       unit: 545,
//       before_vat: 365,
//       after_vat: 419,
//       qty: 1,
//       category: "جديدنا",
//       description:
//         "الخط العطري : ليذر\nعطر امبوريو أرماني سترونجر ويذ يو ليذر Emporio Armani Stronger With You Leather fragrance\nمن اصدارات بيت الأزياء الإيطالي الشهير جورجيو ارماني Giorgio Armani.\nعطر Emporio Armani Stronger With You Leather جلدي فاخر للرجال.\nتم اطلاق العطر حديثاً في عام 2020.\nتوليفة عطرية فواحة مكللة بانتعاش لا يتوقف تفتتحه قمة التكوين مع الكستناء، الملاحظات الحارة وراتنج ايليمي.\nمروراً في قلب التكوين مع المرمية والخزامى.\n\nفي حين تختتمها قاعدة العطر مع العود، خشب الغاياك، الفانيلا والجلد.\n.يحمل العطر توقيع \nالأنف Cecile Matton.\nArmani Stronger With You Leather Eau de Parfum 100ml",
//       basicPrice: 560,
//       stock: 1000000,
//       image:
//         "https://cdn.salla.sa/Qibrg17nPkCg8wQ4TChiy3u2RXI12o7ZrvgQ2Ixp.jpeg",
//       company_id: "62160bc81c5ceec125780794",
//       __v: 0,
//       created_at: "2022-11-17T12:11:43.428Z",
//       updatedAt: "2022-11-29T14:23:58.737Z",
//       imageLocaly:
//         "file:///var/mobile/Containers/Data/Application/4E8EF04D-2D38-4A02-854E-FF12BFE168FB/Library/Caches/ExponentExperienceData/%2540adeb1991%252Fcashier/ImagePicker/7F2870D2-1EF5-4409-A3D7-DE5D1BD8D8DA.jpg",
//       serialNumber: "",
//       category_id: 10,
//     },
//     {
//       _id: "637624ff9f59798d8971e689",
//       name: " نرسيسو بيور مسك اودو برفيوم للنساء100مل - Narciso Rodriguez Pure Musc",
//       key: 23,
//       marker: "نرسيسو",
//       unit: 515.775,
//       before_vat: 345,
//       after_vat: 396.75,
//       qty: 3,
//       category: "الأكثر مبيعا",
//       description:
//         "بيور مسك فور هير من مجموعة نارسيسو رودريغير هو عطر أنثوي أنيق. يمتاز هذا العطر بقلب من المسك، لكنه يمهد لك الطريق أولًا بباقة دافئة من زهور البرتقال والياسمين مرتكزة على قاعدة من الكشميران والعنبر والباتشولي.",
//       basicPrice: 530,
//       category_id: 11,
//       stock: 999998,
//       image:
//         "https://cdn.salla.sa/tP6cgAxiZ8ljfe0MlgqJujFkasymBhHU72TZY6dc.jpeg",
//       company_id: "62160bc81c5ceec125780794",
//       __v: 0,
//       created_at: "2022-11-17T12:11:43.416Z",
//       updatedAt: "2022-11-30T14:07:18.159Z",
//     },
//     {
//       _id: "637624ff9f59798d8971e6e3",
//       name: "ديور سوفاج اودو تواليت للرجال 100مل DIOR SAUVAGE",
//       key: 113,
//       marker: "كريستان ديور",
//       unit: 530,
//       before_vat: 355,
//       after_vat: 408,
//       qty: 1,
//       category: "الأكثر مبيعا",
//       description:
//         "<p>عطر ديور سوفاج أو دو تواليت العطر الرائع والاكثر طلباً وشهرة من عائلة التوابل، عطر جذّاب للرجل الغامض والجريء والمتهور الذي يعيش الحياة بتناقضاتها جامعاً بين الفخامة والبساطة.</p>",
//       basicPrice: 560,
//       category_id: 11,
//       stock: 999999,
//       image:
//         "https://cdn.salla.sa/pnapdF4O6Jzwkr2KBIBH6QcEEbMxaa4EHHYz0ZJR.jpg,https://cdn.salla.sa/NTg7C1KLXHUtWFLYSSbKGyHwvo99J1fVZOL87YZY.jpeg",
//       company_id: "62160bc81c5ceec125780794",
//       __v: 0,
//       created_at: "2022-11-17T12:11:43.420Z",
//       updatedAt: "2022-11-29T09:50:43.966Z",
//       imageLocaly: "",
//       serialNumber: "",
//     },
//   ],
//   user: {
//     country: "السعودية",
//     email: "yaznahmad@gmail.com",
//     displayName: "Cashier Fatora",
//     phone: "0561187856",
//     city: "مكة",
//     address: "خلف باسكن روبيز",
//     neighborhood: "بطحاء قريش",
//     kindPaymentField: "",
//   },
//   price: "2622.32",
// };
